/* eslint-disable global-require */
// These are all the transformers we support
const filterToConfiguratorMap = {
  backgroundBlur: require('./backgroundBlurConfig'),
};

const isSupported = type =>
  !!filterToConfiguratorMap[type];

const getConfigurator = (type) => {
  if (!isSupported(type)) {
    return null;
  }

  return filterToConfiguratorMap[type];
};

const isValidConfig = (config) => {
  const { type } = config;

  if (!isSupported(type)) {
    return false;
  }

  return getConfigurator(type).isValidConfig(config);
};


const MediaTransform = {
  isSupported,
  getConfigurator,
  isValidConfig,
};

module.exports = MediaTransform;
